// extracted by mini-css-extract-plugin
export default {"printTechnicInfoBanner":"PrintTechnicInfoBanner_printTechnicInfoBanner__nmlls"};